export default __webpack_public_path__ + "static/media/badge-agency.10ef533e.svg";